// extracted by mini-css-extract-plugin
export default {"container":"xpr8ztjyKd7gXuQ3lXGJ"};